<template>
  <div>
    <div class="up-input-group">
      <div>
        <up-select
          v-model="bar_chart.type"
          label="Chart type"
          labelIcon="mdi mdi-alpha-s-box-outline"
        >
          <option value="V">Vertical</option>
          <option value="H">Horizontal</option>
        </up-select>
      </div>
      <div>
        <up-textinput
          v-model="bar_chart.title"
          size="md"
          label="Title"
          labelIcon="mdi mdi-alpha-t-box-outline"
        ></up-textinput>
      </div>
      <div>
        <up-textinput
          v-model="bar_chart.x_title"
          size="md"
          label="X-Axis Title"
          labelIcon="mdi mdi-alpha-x-box-outline"
        ></up-textinput>
      </div>
      <div>
        <up-textinput
          v-model="bar_chart.y_title"
          size="md"
          label="Y-Axis Title"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-textinput>
      </div>
      <div>
        <up-numberinput
          v-model="bar_chart.min_val"
          size="xs"
          label="Min Value"
          labelIcon="mdi mdi-chevron-left-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="bar_chart.max_val"
          size="xs"
          label="Max Value"
          labelIcon="mdi mdi-chevron-right-box-outline"
        ></up-numberinput>
      </div>
    </div>
    <div class="up-input-group">
      <div>
        <up-numberinput
          v-model="bar_chart.step_size"
          size="xs"
          label="Stepsize"
          labelIcon="mdi mdi-alpha-s-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-switch
          v-model="bar_chart.is_x_title_bold"
          label="Is X-Axis Title Bold"
          labelIcon="mdi mdi-alpha-x-box-outline"
        ></up-switch>
      </div>
      <div>
        <up-switch
          v-model="bar_chart.is_y_title_bold"
          label="Is Y-Axis Title Bold"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-switch>
      </div>
      <div>
        <up-switch
          v-model="bar_chart.is_legend"
          label="Is Legend"
          labelIcon="mdi mdi-alpha-l-box-outline"
        ></up-switch>
      </div>
      <div>
        <up-switch
          v-model="bar_chart.is_gridlines"
          label="Is Grid Lines"
          labelIcon="mdi mdi-alpha-g-box-outline"
        ></up-switch>
      </div>
    </div>
    <div class="column is-12">
      <p class="title is-5">
        Bars
        <b-button
          @click="addRow"
          type="is-success"
          size="is-small"
          icon-left="plus"
        ></b-button>
      </p>
      <b-collapse
        class="card"
        animation="slide"
        v-for="(bar, index) of bar_chart.properties"
        :key="`BAR${index}`"
        :open="isBarOpen == index"
        @open="isBarOpen = index"
      >
        <template #trigger="props">
          <div class="card-header" role="button">
            <p class="card-header-title">{{ bar.title }}</p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content">
            <b-button
              type="is-info"
              size="is-small"
              @click="
                toggle_custom_layout_cl_drawer = !toggle_custom_layout_cl_drawer
              "
              >Toggle Clipart Drawer</b-button
            >
            <clipart-selector
              v-if="toggle_custom_layout_cl_drawer"
              v-model="bar_chart.properties[index].clipart"
            ></clipart-selector>
            <div class="up-input-group">
              <div>
                <up-textinput
                  v-model="bar.title"
                  size="md"
                  label="Title"
                  labelIcon="mdi mdi-alpha-t-box-outline"
                ></up-textinput>
              </div>
              <div>
                <up-numberinput
                  v-model="bar.value"
                  size="xs"
                  label="Value"
                  labelIcon="mdi mdi-chevron-right-box-outline"
                ></up-numberinput>
              </div>
              <div>
                <up-switch
                  v-model="bar.is_user_select_points"
                  label="Is Selectable"
                  labelIcon="mdi mdi-alpha-s-box-outline"
                ></up-switch>
              </div>
              <div v-if="bar.is_user_select_points">
                <up-numberinput
                  v-model="bar.answer"
                  size="xs"
                  label="Answer"
                  labelIcon="mdi mdi-alpha-a-box-outline"
                ></up-numberinput>
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column is-12">
                <style-editor show_bg_color v-model="bar.styles"></style-editor>
              </div>
            </div>

            <b-button
              @click="removeRow(index)"
              type="is-danger"
              size="is-small"
              icon-left="close"
            ></b-button>
          </div>
        </div>
      </b-collapse>
    </div>
    <div class="column is-6">
      <show-bar-chart :bar_chart="bar_chart"></show-bar-chart>
      <!-- {{bar_chart}}  -->
    </div>
  </div>
</template>

<script>
import ShowBarChart from "./ShowBarChart.vue";
import { defaultBarChartValue } from "./utils";
import ClipartSelector from "../Clipart/ClipartSelector.vue";
import StyleEditor from "../../Common/StyleEditor/StyleEditor.vue";

import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSwitch from "@/components/UI/Inputs/UpSwitch";
import UpSelect from "@/components/UI/Inputs/UpSelect";

export default {
  name: "set-bar-chart",
  props: {
    value: {
      type: Object,
    }, // Here value = new_question.bar_chart
  },
  components: {
    ShowBarChart,
    ClipartSelector,
    StyleEditor,
    UpTextinput,
    UpNumberinput,
    UpSwitch,
    UpSelect,
  },
  data() {
    return {
      isBarOpen: null,
      bar_chart: this.value ? this.value : defaultBarChartValue(),
      toggle_custom_layout_cl_drawer: false,
    };
  },
  methods: {
    addRow() {
      this.bar_chart.properties.push({
        title: "",
        value: null,
        clipart: null,
        styles: {},
        answer: null,
        is_user_select_points : false
      });
    },
    removeRow(index) {
      this.bar_chart.properties.splice(index, 1);
    },
  },
  watch: {
    bar_chart: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.bar_chart = new_val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
